module.exports = __webpack_public_path__ + "static/media/l5.31a37b44.jpg";